import React, { useCallback, useState } from "react";
import { DispatchTableEvent, DispatchTransactionEvent } from "../events/events";
import {
  ShowError, confirmationDialog, 
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
  JSON_KEY_SUBMITTER, 
  JSON_KEY_USER,
  JSON_KEY_INSTRUMENT,
  DELETE_TABLE,
  EVENT_TYPE_TRADE_REQUEST_TRADE_NUMBER,
  EVENT_TYPE_TRADE_REQUEST_USER,
  JSON_KEY_TRADE_NUMBER,
  USERS_TRADES_TABLE,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSG_TYPE_TRADE_SEARCH_REQUEST } from "../../common/msg_types";
import { RenderDropdown, InputField } from "../../common/utilies";

const ITEM_TRADE_NUMBER = "trade_number";
const ITEM_USER_AND_INSTRUMENT = "user_and_instrument";

const TradeRequestForm = ({ onClose, usersOptions, instrumentsOptions }) => {
   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   const [tradeNumber, setTradeNumber] = useState("");
   const [instrumentCode, setInstrumentCode] = useState("");
   const [userCode, setUserCode] = useState("");
   const [removeExistingTrades, setRemoveExistingTrades] = useState(false);

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onUserDropDownChange = useCallback((e) => setUserCode(e.target.value), [setUserCode]);
   const onInstrumentDropDownChange = useCallback((e) => setInstrumentCode(e.target.value), [setInstrumentCode]);

   const ConfirmAndSubmit = async ({ title, text, item }) => {
      const confirmed = await confirmationDialog({ title, text });
      if (confirmed) handleStatusConfirmationSubmit(item);
   };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const base = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_TRADE_SEARCH_REQUEST,
      };

      switch (submitItem) {
         case ITEM_TRADE_NUMBER:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_TRADE_REQUEST_TRADE_NUMBER,
               {
                  ...base,
                  [JSON_KEY_TRADE_NUMBER]: Number(tradeNumber),
               }
            );
            break;

         case ITEM_USER_AND_INSTRUMENT:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_TRADE_REQUEST_USER,
               {
                  ...base,
                  [JSON_KEY_USER]: userCode,
                  [JSON_KEY_INSTRUMENT]: instrumentCode,
               }
            );
            break;

         default:
            console.log("Trade Request unknown submit item");
      }

      if (removeExistingTrades) {
         // console.log("Remove existing trades option selected.");
         DispatchTableEvent(DELETE_TABLE, USERS_TRADES_TABLE, "");
      }
   };

   const handleTradeNumberSubmit = () => {
      if (tradeNumber === undefined || !tradeNumber) return ShowError("Enter trade number");

      ConfirmAndSubmit({
         title: "Trades Request",
         text: `Request for trade: ${tradeNumber}`,
         item: ITEM_TRADE_NUMBER,
      });
      
      onClose(); // your modal close function
   };

   const handleUserAndInstrumentSubmit = () => {
      if (userCode === undefined || !userCode) return ShowError("User code is missing");
      if (instrumentCode === undefined || !instrumentCode) return ShowError("Instrument is missing");

      ConfirmAndSubmit({
         title: "Trades Request",
         text: `Request for trades, user: ${userCode} and instrument ${instrumentCode}`,
         item: ITEM_USER_AND_INSTRUMENT,
      });

      onClose(); // your modal close function
   };

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Trade Request</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Trade Number</Tab>
               <Tab>Trader & Instrument</Tab>
            </TabList>

            {/* Tab 1: Request by trade number */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleTradeNumberSubmit)}>
               <div>
                  <InputField label="Trade Number" value={tradeNumber} onChange={setTradeNumber} type="number" />
               </div>

               <div >
                  <label className="form-label">
                     Remove Existing Trades { }
                     <input
                        type="checkbox"
                        style={{ transform: 'scale(2)', margin: '10px' }} 
                        checked={removeExistingTrades}
                        onChange={(e) => setRemoveExistingTrades(e.target.checked)}
                     />
                  </label>
               </div>
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 2: Request by user and instrument */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleUserAndInstrumentSubmit)}>
               <div className="top">
                  {RenderDropdown("Trader", userCode, usersOptions, onUserDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Instrument", instrumentCode, instrumentsOptions, onInstrumentDropDownChange)}
               </div>

               <div >
                  <label className="form-label">
                     Remove Existing Trades { }
                     <input
                        type="checkbox"
                        style={{ transform: 'scale(2)', margin: '10px' }} 
                        checked={removeExistingTrades}
                        onChange={(e) => setRemoveExistingTrades(e.target.checked)}
                     />
                  </label>
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
         </Tabs>
         </div>
      </div>
   );
};

export default TradeRequestForm;
